import { render, staticRenderFns } from "./WidgetManager.vue?vue&type=template&id=0296fa5f&scoped=true"
import script from "./WidgetManager.vue?vue&type=script&lang=js"
export * from "./WidgetManager.vue?vue&type=script&lang=js"
import style0 from "./WidgetManager.vue?vue&type=style&index=0&id=0296fa5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0296fa5f",
  null
  
)

export default component.exports